export enum LegacyAllergenCategories {
  ANIMAL_PROTEINS = 5,
}
